import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import { Loader2, Lock, AlertTriangle } from "lucide-react";
import SEO from "../components/SEO";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.toLowerCase().trim(), password);
      navigate("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--mc-navy-950)] hex-grid px-5 pt-24 pb-16" data-testid="page-admin-login">
      <SEO title="Connexion admin" description="Espace admin MetaConnect." canonical="/admin/login" noIndex />
      <div className="mc-card w-full max-w-md p-8">
        <div className="grid place-items-center h-12 w-12 rounded-xl bg-[rgba(45,123,255,0.15)] border border-[rgba(127,179,255,0.28)] text-[#0284C7]">
          <Lock size={22} />
        </div>
        <h1 className="font-display text-[#0F2B5B] text-2xl mt-5">Espace admin</h1>
        <p className="mt-2 text-[13px] text-[var(--mc-muted)]">
          Connectez-vous pour gérer les articles du blog.
        </p>

        <form onSubmit={onSubmit} className="mt-7 grid gap-4" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-[12px] uppercase tracking-[0.16em] text-[#475569] mb-2">Email</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mc-input" placeholder="vous@metaconnect.fr" />
          </label>
          <label className="block">
            <span className="block text-[12px] uppercase tracking-[0.16em] text-[#475569] mb-2">Mot de passe</span>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mc-input" placeholder="••••••••" />
          </label>

          {err && (
            <div data-testid="admin-login-error" className="flex items-start gap-2 rounded-lg border border-[rgba(255,120,120,0.35)] bg-[rgba(255,120,120,0.08)] px-4 py-3 text-[13px] text-[#DC2626]">
              <AlertTriangle size={16} className="mt-0.5" /><span>{err}</span>
            </div>
          )}

          <button
            type="submit" disabled={loading} data-testid="admin-login-submit"
            className="btn-primary px-6 py-3 rounded-full font-medium inline-flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <Link to="/" className="mt-6 inline-block text-[12px] text-[var(--mc-muted)] link-underline">
          ← Retour au site
        </Link>
      </div>
    </div>
  );
}
